export const required = (value) =>
  value ? undefined : "The field is required."
export const isNumber = (value) =>
  !!value
    ? Number.isInteger(parseInt(value))
      ? undefined
      : "This field must be a number."
    : undefined
export const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    )
